import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-ebay',
  templateUrl: './invoice-ebay.component.html',
  styleUrls: ['./invoice-ebay.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceEbayComponent extends InvoiceComponent implements OnInit {
  displayedColumns: string[] = ['sku', 'item', 'desc', 'qty', 'price', 'actions'];

  @Input()
  invoice: InvoiceInterface;

  defaultInvoice = {
    type: "ebay",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-ebay"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
